import script from "./FavoriteArtWork.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteArtWork.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteArtWork.vue?vue&type=style&index=0&id=e34df57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e34df57a"]])

export default __exports__